import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Confirmation.css';

interface LocationState {
  orderId?: string;
  orderReference?: string;
  paymentMethod?: 'cash' | 'mpesa' | 'orange_money';
}

const Confirmation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  const handleBackHome = () => {
    navigate('/');
  };

  return (
    <div className="confirmation-page">
      <div className="confirmation-container">
        <div className="success-icon">✓</div>
        <h1>Demande envoyée avec succès!</h1>
        <p>
          Votre demande de livraison a été bien reçue. 
          Nous vous contacterons bientôt pour confirmer les détails.
        </p>
        <div className="reference-info">
          <p className="reference-label">Numéro de référence:</p>
          <p className="reference-number">
            {state?.orderReference || `WD-${Date.now().toString().slice(-6)}`}
          </p>
        </div>
        {state?.paymentMethod === 'mpesa' && (
          <div className="payment-info-confirmation">
            <h3>Paiement M-Pesa</h3>
            <p className="payment-number">0822193993</p>
          </div>
        )}
        {state?.paymentMethod === 'orange_money' && (
          <div className="payment-info-confirmation">
            <h3>Paiement Orange Money</h3>
            <p className="payment-number">0842193989</p>
          </div>
        )}
        {state?.paymentMethod === 'cash' && (
          <div className="payment-info-confirmation">
            <h3>Paiement en espèces</h3>
            <p className="payment-number">Paiement à la livraison</p>
          </div>
        )}
        <button className="home-button" onClick={handleBackHome}>
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
};

export default Confirmation;